import { render, staticRenderFns } from "./connectionfail.vue?vue&type=template&id=e4eeb4ba&lang=pug"
import script from "./connectionfail.vue?vue&type=script&lang=js"
export * from "./connectionfail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports